import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../Card';
import { getContentSubType } from '../../../helpers';

import './style.scss';

const DEFAULT_ITEMS_TO_DISPLAY = 6;

const GetStarted = ({ title, subtitle, content, getStartedRef }) => {
  const { t } = useTranslation();
  const [itemsToDisplay, setItemsToDisplay] = useState(DEFAULT_ITEMS_TO_DISPLAY);
  // Fallback to translation if no Title is set.
  title = !title ? t('get_started.title') : title;

  return content.size > 0 && (
    <div className="GetStarted__get_started" id="GetStarted__get_started" ref={getStartedRef}>
      <Container>
        <h2 className="GetStarted__get_started__title">{title}</h2>
        <p className="GetStarted__get_started__subtitle">{subtitle}</p>
        <div className="GetStarted__get_started__content">
          <div className="row">

            {content.slice(0, itemsToDisplay).map((item) => {
              const url = item.get('url');
              const type = item.getIn(['entity', 'type', 0, 'target_id']) || item.getIn(['entity', 'vid', 0, 'target_id']);
              const subType = item.getIn(['entity', getContentSubType(item.getIn(['entity', 'type', 0, 'target_id'])), 0, 'entity', 'name', 0, 'value'], item.getIn(['entity', 'type', 0, 'target_id'])) || type;
              const itemTitle = item.getIn(['entity', 'title', 0, 'value']) || item.getIn(['entity', 'name', 0, 'value']);
              const uuid = item.getIn(['entity', 'uuid', 0, 'value']);
              const image = item.getIn(['entity', 'field_media_image', 0, 'styles', '1_1'], null);
              const imageAlt = item.getIn(['entity', 'field_media_image', 0, 'alt'], '');
              return (
                <div key={uuid} className="GetStarted__get_started__content__card col-12 col-md-6 col-lg-4">
                  <Card small title={itemTitle} image={image} type={type} subType={subType} link={url} alt={imageAlt} />
                </div>
              );
            },
            )}
            {itemsToDisplay < content.size && (
              <div className="col-12 ReadMore">
                <Button
                  className="Button Button--ghost"
                  onClick={() => {
                    setItemsToDisplay(itemsToDisplay + DEFAULT_ITEMS_TO_DISPLAY);
                  }}>
                  <span>Laat meer zien <i className="icon icon-arrow-right" /></span>
                </Button>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};
export default GetStarted;
